const ConversationStatus = {
	active: 'active',
	archived: 'archived',
	read: 'read',
	censored: 'censored',
	locked: 'locked',
	deleted: 'deleted',
};

export default ConversationStatus;
